"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensFieldsDisplayGrid = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var QueryPreservingLinkCellFormatter_1 = require("../datagrid/cellFormatters/QueryPreservingLinkCellFormatter");
var SvgFieldIcon_1 = require("../field/components/SvgFieldIcon");
var FieldNameMapping_1 = require("../field/functions/FieldNameMapping");
var DescriptionInfo_1 = require("../fieldColumn/DescriptionInfo");
var FieldsDisplayGrid_1 = require("../sharedDisplayGrid/FieldsDisplayGrid");
var columns = [
    function (sortParams) { return ({
        name: 'type',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderType(),
        headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
        cellFormatter: (0, data_catalog_shared_1.createIconCellFormatter)(function (_a) {
            var fieldIcon = _a.fieldIcon;
            return react_1.default.createElement(SvgFieldIcon_1.SvgFieldIcon, { fieldIcon: fieldIcon });
        }, function (_a) {
            var fieldIcon = _a.fieldIcon;
            return fieldIcon ? FieldNameMapping_1.FieldNameMappings[fieldIcon]() : '';
        }),
        sortable: false,
        resizable: false
    }); },
    function (sortParams) { return ({
        name: 'name',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderName(),
        headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
        cellFormatter: (0, QueryPreservingLinkCellFormatter_1.createQueryPreservingReplacingLinkCellFormatter)(FieldsDisplayGrid_1.getNameWithApplicableDataType, function (urls, _a) {
            var id = _a.id, lensId = _a.lensId;
            return urls.lensLineageFieldPath(lensId, id);
        }),
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'description',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderDescription(),
        headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
        cellFormatter: descriptionCellFormatter(),
        sortable: false,
        growToFit: true,
    }); },
];
function LensFieldsDisplayGrid(props) {
    var cols = columns.map(function (columnFactory) { return columnFactory(props); });
    return (react_1.default.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.LensFieldsDisplayGrid = LensFieldsDisplayGrid;
// Following functions adapted from DatasourceFieldsDisplayGrid.tsx:
function descriptionCellFormatter() {
    return (0, data_catalog_shared_1.createTextCellFormatter)(descriptionTextFromRowData, // getTextFromRowData
    Localize_1.Messages.NoDescriptionGridPlaceholder(), // placeholder
    function () { return false; }, // getDisabledFromRowData (always enabled)
    false, // noPadding
    descriptionIconFromRowData);
}
function minifyRowData(rowData) {
    return {
        description: rowData.description,
    };
}
function descriptionTextFromRowData(rowData) {
    return (0, DescriptionInfo_1.DescriptionTextFromRowData)(minifyRowData(rowData));
}
function descriptionIconFromRowData(rowData) {
    return (0, DescriptionInfo_1.DescriptionIconFromRowData)(minifyRowData(rowData));
}
//# sourceMappingURL=LensFieldsDisplayGrid.js.map